module.exports = __webpack_public_path__ + "img/vue.1ce3d48e.png";